import { get, set } from 'lodash-es';

export class LocalStorageService<
    Value,
    Key extends string,
    State extends Partial<Record<Key, Value>> = Partial<Record<Key, Value>>,
> {
    constructor(
        private _storageKey: string,
        private _key: Key,
        private _defaultValue: Value,
    ) {}

    get(): Value {
        const state = this.#getState();
        const value = get(state, this._key) as Value;

        return value ?? this._defaultValue;
    }

    set(value: Value | undefined) {
        const state = this.#getState();
        set(state, this._key, value);
        this.#patchState(state);
    }

    reset() {
        this.set(undefined);
    }

    #getState = () =>
        JSON.parse(localStorage.getItem(this._storageKey) ?? '{}') as State;

    #patchState = (newState: State) => {
        localStorage.setItem(this._storageKey, JSON.stringify(newState));
    };
}
